function filterScoreRange() {
  const scoreDivs = document.querySelectorAll(
    '.ays_message > div[data-score-range]',
  );
  scoreDivs.forEach(div => {
    const currentScore = parseInt(div.getAttribute('data-score-range'), 10);
    const minScore = parseInt(div.getAttribute('data-score-min-range'), 10);
    const maxScore = parseInt(div.getAttribute('data-score-max-range'), 10);

    if (currentScore < minScore || currentScore > maxScore) {
      div.parentNode.removeChild(div);
    }
  });
}

function onContentChange(mutationList) {
  mutationList.forEach(mutation => {
    if (mutation.type === 'childList' || mutation.type === 'characterData') {
      filterScoreRange();
    }
  });
}

const mutationObserver = new MutationObserver(onContentChange);

function handleVisibilityChange(entries) {
  entries.forEach(entry => {
    if (entry.isIntersecting) {
      const targetMessageDiv = entry.target.querySelector('.ays_message');
      if (targetMessageDiv) {
        mutationObserver.observe(targetMessageDiv, {
          characterData: true,
          childList: true,
          subtree: true,
        });
      }
    }
  });
}

const observer = new IntersectionObserver(handleVisibilityChange, {
  root: null,
  rootMargin: '0px',
  threshold: 0.1,
});

const targetContainer = document.querySelector('.step.ays_thank_you_fs');
if (targetContainer) {
  observer.observe(targetContainer);
}
